import React from 'react';
import { InboxIcon } from 'lucide-react';
import type { DayGroup } from '../../types/activity';
import type { Density } from '../../types/ui';
import { ActivityRow } from './ActivityRow';
interface TimelineListProps {
  groups: DayGroup[];
  density: Density;
  selectedId: string | null;
  onSelect: (id: string) => void;
}
export function TimelineList({
  groups,
  density,
  selectedId,
  onSelect
}: TimelineListProps) {
  if (groups.length === 0) {
    return <div className="flex flex-col items-center justify-center gap-2 px-6 py-20 text-center" data-id="element-75" data-mp="21w535sh81cno">
        <InboxIcon className="h-6 w-6 text-ink-subtle" aria-hidden="true" data-id="element-76" data-mp="25x8i8crg34nu" />
        <p className="font-display text-[14px] font-bold text-ink" data-id="element-77" data-mp="1rza85jk5pue5">
          No activity matches these filters
        </p>
        <p className="max-w-xs text-[13px] text-ink-muted" data-id="element-78" data-mp="1x0ps18alluuy">
          Try a different channel or clear the search to see the full history.
        </p>
      </div>;
  }
  return <div className="pb-8" data-id="element-79" data-mp="ll14aepisrt3">
      {groups.map(group => <section key={group.key} aria-label={`${group.label}, ${group.dateLabel}`} data-id="element-80" data-mp="1wjbsbtui8z8b">
          <div className="sticky top-0 z-10 flex items-baseline gap-2 border-b border-line bg-surface px-6 py-2" data-id="element-81" data-mp="1sj04y9arckt5">
            <h2 className="font-display text-[11.5px] font-bold uppercase tracking-[0.08em] text-ink" data-id="element-82" data-mp="26jaxrhvmo9gy">
              {group.label}
            </h2>
            <span className="text-[12px] text-ink-subtle" data-id="element-83" data-mp="21lj7esamsvev">
              {group.dateLabel} · {group.count}{' '}
              {group.count === 1 ? 'entry' : 'entries'}
            </span>
          </div>

          <ul className="divide-y divide-line" data-id="element-84" data-mp="2bfjirbwiaww1">
            {group.activities.map(activity => <li key={activity.id} data-id="element-85" data-mp="2palljq62464m">
                <ActivityRow activity={activity} selected={selectedId === activity.id} density={density} onSelect={onSelect} data-id="element-86" data-mp="2k9efbvjkbf02" />
              </li>)}
          </ul>
        </section>)}
    </div>;
}